<template>
  <div>
    <div v-if="isEditPwd" class="back-line black-14" @click="isEditPwd = false"><i class="iconfont icon-fanhui2"></i>返回
    </div>
    <div v-if="!isEditPwd" class="right-cont">
      <div class="page-name">账号管理</div>
      <div class="person-input-item">
        <div class="user-label">手机号</div>
        <div class="user-tip">若需要更换手机号，请联系客服或管理员处理</div>
        <input class="small-input user-input dis-input" type="text" disabled v-model="member.telephone">
      </div>
      <div class="person-input-item">
        <div class="user-label">密码</div>
        <div class="user-tip">新注册的账号，首次修改密码成功后方可使用密码登录</div>
        <div class="d-flex">
          <input class="small-input user-input dis-input" value="********" disabled>
          <div class="add-btn" style="width: 88px" @click="isEditPwd = true">修改</div>
        </div>
      </div>
    </div>
    <div v-else class="right-cont">
      <div class="page-name">修改密码</div>
      <div class="user-label">新密码</div>
      <input class="small-input user-input" placeholder="输入新密码" v-model="form.password" type="password">
      <div class="user-label">确认新密码</div>
      <input class="small-input user-input" placeholder="请再次输入新密码" v-model="form.confirm_password" type="password">
      <div class="take-dialog-bottom" style="justify-content: left">
        <div class="take-dialog-open" style="margin-left: 0" @click="submitForm">保存</div>
      </div>

    </div>
  </div>
</template>

<script>
import { user_info, modifyPassword } from "@/http/user_center";

export default {
  name: "account",
  data() {
    return {
      isEditPwd: false,
      form: {
        password: undefined,
        confirm_password: undefined,
      },
      formLoading: false,
      member: {}
    };
  },
  created(){
    this.getData();
  },
  methods: {
    getData() {
      user_info().then((res) => {
        this.member = res.data;
      });
    },
    submitForm() {
      if (!this.form.password) {
        return this.$message.error("新密码不能为空");
      }
      if (!this.form.confirm_password) {
        return this.$message.error("确认新密码不能为空");
      }
      if (this.form.password !== this.form.confirm_password) {
         return this.$message.error("两次输入的密码不一致");
      }
      if (this.formLoading) {
        return;
      }
      this.formLoading = true;
      modifyPassword(this.form)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.isEditPwd = false;
            this.resetForm();
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "修改失败");
          }
          this.formLoading = false;
        })
        .catch(() => {
          this.formLoading = false;
        });
    },
    resetForm() {
      this.form = {
        password: undefined,
        confirm_password: undefined,
      };
    },
  },
};
</script>


<style scoped src="../../assets/css/user_center.css"></style>
